import { createContext, useContext } from "react"

/**
 * Renders the "Ändra servicedatum" dialog for a job.
 *
 * Injected via context so the shared UniversalJobCard never imports the CRM
 * api/query layer directly — that keeps the component renderable in Storybook,
 * where no renderer is provided and the menu item is simply hidden.
 */
export type HandInDateDialogRenderer = (props: {
  jobId: string
  currentHandInDate: Date
  onOpenChange: (open: boolean) => void
}) => React.ReactNode

const HandInDateDialogRendererContext =
  createContext<HandInDateDialogRenderer | null>(null)

export const HandInDateDialogRendererProvider =
  HandInDateDialogRendererContext.Provider

export function useHandInDateDialogRenderer(): HandInDateDialogRenderer | null {
  return useContext(HandInDateDialogRendererContext)
}
